import { IRuleGroupService } from "../../service/evaluation/RuleGroupService";
import { IRuleGroup } from "../../model/evaluation/RuleGroup";
import { IRuleGroupElement } from "../../model/evaluation/RuleGroupElement";

export default class UpdateBusinessRuleInRuleGroupInteractor {
  private ruleGroupService: IRuleGroupService;

  constructor(ruleGroupService) {
    this.ruleGroupService = ruleGroupService;
  }

  async execute(ruleGroup: IRuleGroup, element: IRuleGroupElement) {
    return this.ruleGroupService.updateRuleFromRuleGroup(ruleGroup, element);
  }
}
